export default __webpack_public_path__ + "static/fred-42bb7e6d24d101523353be5b2130e42c.jpg";